import "./PrimaryButton.css";
import Button from "react-bootstrap/Button";

function PrimaryButton(props) {
    return (
        <Button className="primary-button" variant="light" onClick={props.onClick} disabled={props.disabled} title={props.title}>{props.text}</Button>
    )
}

export default PrimaryButton;